import React, { Component } from 'react';
import Banner from './Sections/Banner/Banner';
import Features from './Sections/Features/Features';
import Works from './Sections/Works/Works';
import Team from './Sections/Team/Team';
import Testimonials from './Sections/Testimonials/Testimonials';

export class Home extends Component {
  render() {
    return (
      <div>
        <Banner/>
        <Features/>
        <Works/>
        <Team/>
        <Testimonials/>
      </div>
    );
  }
}
